
import Professionnels from "@/pages/services/Professionnels";
import Collectivites from "@/pages/services/Collectivites";
import Particuliers from "@/pages/services/Particuliers";
import Vehicules from "@/pages/services/Vehicules";
import HuilesMinérales from "@/pages/services/HuilesMinérales";
import HuilesAlimentaires from "@/pages/services/HuilesAlimentaires";

// Service client routes
export const serviceClientRoutes = [
  { path: "/services/professionnels", element: Professionnels },
  { path: "/services/collectivites", element: Collectivites },
  { path: "/services/particuliers", element: Particuliers },
  { path: "/services/vehicules", element: Vehicules },
  { path: "/services/huiles-minerales", element: HuilesMinérales },
  { path: "/services/huiles-alimentaires", element: HuilesAlimentaires },
];
